import { createContext } from 'react';

export const DistributionListContext = createContext(null);
